import React, { createContext, useContext } from 'react';

export type ToastVariant = 'default' | 'destructive';

export interface ToastOptions {
  title?: string;
  description?: string;
  variant?: ToastVariant;
  duration?: number; // ms
}

type ToastContextValue = {
  toast: (options: ToastOptions) => void;
  dismiss: (id?: string) => void;
};

export const ToastContext = createContext<ToastContextValue | undefined>(undefined);

export function useToast(): ToastContextValue {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error('useToast must be used within AppToasterProvider');
  }
  return ctx;
}
